var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBitcoincash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17267_78906)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36 72C55.8823 72 72 55.8823 72 36C72 16.1178 55.8823 0 36 0C16.1178 0 0 16.1178 0 36C0 55.8823 16.1178 72 36 72Z",
    fill: "#0AC18E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.2295 23.9117C45.4203 19.8091 41.263 18.932 36.1736 19.7817L34.5381 13.4406L30.6823 14.4366L32.2904 20.7594C31.2762 21.0152 30.2346 21.2345 29.2021 21.5269L27.5939 15.2406L23.7381 16.2366L25.3736 22.5777C24.5422 22.8152 17.5889 24.597 17.5889 24.597L18.6488 28.7269C18.6488 28.7269 21.4813 27.932 21.4538 27.9959C23.0254 27.5848 23.7655 28.3706 24.1127 29.1107L28.6082 46.4893C28.663 46.9919 28.5716 47.8508 27.4934 48.1432C27.5574 48.1797 24.6884 48.865 24.6884 48.865L25.1087 53.6802C25.1087 53.6802 31.998 51.9168 32.9026 51.6883L34.5564 58.1025L38.4122 57.1066L36.7584 50.6467C37.8183 50.4 38.8508 50.1442 39.8559 49.8792L41.5005 56.3025L45.3564 55.3066L43.7026 48.9015C49.6417 47.4579 53.8356 43.7117 52.9767 37.9827C52.4285 34.5289 48.6549 31.6964 45.5208 31.3767C47.4488 29.668 48.4264 27.1736 47.2295 23.9117ZM45.3747 39.0335C46.1422 44.7076 38.2569 45.402 35.6528 46.0873L33.3868 37.599C36 36.9137 44.0772 34.0355 45.3747 39.0335ZM40.6234 27.4751C41.4366 32.5188 34.6934 33.1036 32.5188 33.6609L30.4538 25.9584C32.6376 25.4193 38.9696 22.8061 40.6234 27.4751Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17267_78906"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBitcoincash);
export default __webpack_public_path__ + "static/media/bitcoincash.ce05fdd66538d29a1694e89fa54701e0.svg";
export { ForwardRef as ReactComponent };